import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flexWrap" }
const _hoisted_2 = { class: "flexAlign right" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "right_left" }, "上传文件：", -1)
const _hoisted_4 = { class: "flexAlign right" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "right_left" }, " ", -1)
const _hoisted_6 = { class: "right_right" }
const _hoisted_7 = ["href"]
const _hoisted_8 = ["href"]
const _hoisted_9 = ["href"]
const _hoisted_10 = {
  class: "flexWrap",
  style: {"margin":"10px 0px"}
}
const _hoisted_11 = {
  slot: "footer",
  class: "flexCenter"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("导入")

import{
        apiName
    } from '@/api/api.js';
    import { requestAddUser,requestUserDetails,requestExcelImport } from '@/api/api'
	import { ref,onMounted } from 'vue'
	import { ElMessage } from 'element-plus'
	
export default /*#__PURE__*/_defineComponent({
  name: 'Excel',
  props: {
		id:{
			type: String,
			default: ""
		}
	},
  emits: ['cancel'],
  setup(__props, { emit }) {

const props = __props

	const textarea = ref('')
    const api = ref(apiName)
	
	
	const pz = ref<any>({
        datapath:'',//内容地址1
    })
   
	onMounted(()=>{
	})
	const datapathsuccess=  (response:any) => {
        console.log(response);
        pz.value.datapath=response.data[0].url;
    }
	const qx = () =>{
		emit("cancel")
		textarea.value="";
		pz.value.datapath="";
	}
    const submit = () =>{
		if(pz.value.datapath=== ""){
			ElMessage.error("请上传Excel文件");
			return
		}
        requestExcelImport({
            lx:props.id,
            filepath:pz.value.datapath,
        }).then((res:any)=>{
            if(res.status === 1){
                ElMessage({
                    message: res.msg,
                    type: 'success',
                    duration: 500
                });
				setTimeout(()=>{
					emit("cancel")
				},500)
            }else{
            textarea.value=res.msg;
	            ElMessage({
                    message: res.msg,
					type: 'error',
					duration:500
				})
            }
        })
    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_form, {
      "label-width": "40px",
      style: {"background-color":"#fff"},
      "show-message": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createVNode(_component_el_upload, {
              action: `${api.value}/frame/uploadfile1`,
              "show-file-list": false,
              class: "right_right",
              accept: ".xlsx",
              "on-success": datapathsuccess
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"100%"},
                  class: "right_right",
                  size: "small",
                  modelValue: pz.value.datapath,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((pz.value.datapath) = $event)),
                  placeholder: "请输入内容地址"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["action"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              (props.id=='用户导入')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: `${api.value}/upload1/用户导入.xlsx`,
                    target: "_blank",
                    style: {"color":"#333"}
                  }, "下载用户导入模板", 8, _hoisted_7))
                : _createCommentVNode("", true),
              (props.id=='组织架构导入')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: `${api.value}/upload1/组织架构导入.xlsx`,
                    target: "_blank",
                    style: {"color":"#333"}
                  }, "下载组织架构导入模板", 8, _hoisted_8))
                : _createCommentVNode("", true),
              (props.id=='组织架构导入用户')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 2,
                    href: `${api.value}/upload1/组织架构导入用户.xlsx`,
                    target: "_blank",
                    style: {"color":"#333"}
                  }, "下载组织架构导入用户模板", 8, _hoisted_9))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_el_input, {
            modelValue: textarea.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((textarea).value = $event)),
            rows: 2,
            "input-style": "color: red;",
            type: "textarea",
            disabled: "true",
            placeholder: ""
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_el_button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (qx()))
      }, {
        default: _withCtx(() => [
          _hoisted_12
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        style: {"color":"#fff"},
        type: "primary",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (submit()))
      }, {
        default: _withCtx(() => [
          _hoisted_13
        ]),
        _: 1
      })
    ])
  ], 64))
}
}

})